<script setup lang="ts">
import { useCommonStore } from "~/stores/common/store";

const props = defineProps({
  page: {
    type: String,
    required: true,
  },
  location: {
    type: String,
    required: true,
  },
});

const commonStore = useCommonStore();
const { getBannerByPageAndLocation } = commonStore;

const currentBanner = computed(() => {
  return getBannerByPageAndLocation(props.page, props.location);
});

function handleBannerClick() {
  useTrackEvent("banner_click", {
    banner_name: currentBanner.value?.name,
    conversionValue: 1,
  });

  console.log(`Banner ${currentBanner.value?.name} clicked`);
}

watch(
  () => currentBanner.value,
  (value) => {
    if (value) {
      useTrackEvent("banner_impression", {
        banner_name: value.name,
        conversionValue: 1,
      });
      console.log(`Banner ${value.name} impression`);
    }
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<template>
  <div
    v-if="currentBanner"
    class="mx-2 mb-10 flex justify-center"
    :class="[
      {
        '!mx-0 mt-10 rounded-lg border border-surface-border p-2':
          props.page === 'marketing',
      },
    ]"
  >
    <NuxtLink
      class="hidden lg:block"
      :to="currentBanner.ad_link"
      target="_blank"
      @click="handleBannerClick"
    >
      <img
        :src="currentBanner.desktop_url"
        alt="top_banner"
        class="w-full lg:w-[970px]"
        :class="[{ '!w-screen': props.page === 'marketing' }]"
      />
    </NuxtLink>

    <NuxtLink
      class="lg:hidden"
      :to="currentBanner.ad_link"
      target="_blank"
      @click="handleBannerClick"
    >
      <img
        :src="currentBanner.mobile_url"
        alt="top_banner"
        class="w-full lg:w-[970px]"
        :class="[{ '!w-screen': props.page === 'marketing' }]"
      />
    </NuxtLink>
  </div>
</template>

<style scoped></style>
